var _this = this;
import * as tslib_1 from "tslib";
import { getSuggestions, onSearchTextChanged } from '../actions/publicActions';
import { getStore } from '../store/store';
import { orchestrator } from 'satcheljs';
import { setSearchText, setSearchTextForSuggestion, updateGhostText, } from '../actions/internalActions';
export default orchestrator(onSearchTextChanged, function (actionMessage) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
    var searchText;
    return tslib_1.__generator(this, function (_a) {
        searchText = actionMessage.searchText;
        // Always set the search text in response to search box text changing.
        setSearchText(searchText);
        /**
         * Update ghost text (ensure new search text is prefix of current ghosted
         * suggestion).
         */
        updateGhostText();
        /**
         * If searchTextForSuggestion is different than new searchText, dispatch action
         * to update searchTextForSuggestion in the store, and dispatch action to
         * get new suggestions.
         */
        if (getStore().searchTextForSuggestion !== searchText) {
            setSearchTextForSuggestion(searchText);
            getSuggestions();
        }
        return [2 /*return*/];
    });
}); });
//# sourceMappingURL=onSearchTextChangedOrchestrator.js.map